import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ComponentCleaner} from '../../../component-cleaner';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {filter, switchMap} from 'rxjs/operators';

import {AdUserDaoService} from '../ad-user-dao.service';
import {buildAdPasswordInlineWarning, checkAdPasswordPolicy} from '../ad-password-rules';
import {confirmAdPasswordIfNeeded} from '../ad-password-confirm';
import {ADDomain, ADUser, ADUserWithPassword} from '../../../models';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-ad-user-password-update',
    templateUrl: './ad-user-password-update.component.html',
    styleUrls: ['./ad-user-password-update.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdUSerPasswordUpdateComponent extends ComponentCleaner {
    private readonly destroyRef = inject(DestroyRef);
    private readonly cdr = inject(ChangeDetectorRef);
    public adPasswordWarning = '';
    public myForm!: FormGroup;
    public adUserPassword: FormControl = new FormControl<string | null>(null);
    public adUser!: ADUser;
    public adDomain!: ADDomain;
    public adUserWithPassword: ADUserWithPassword = {
        adUser: null,
        askThePassword: false,
        adUserPassword: null,
        adUserAlreadyExists: false,
        subProjectId: null
    };

    constructor(
        public dialogRef: MatDialogRef<AdUSerPasswordUpdateComponent>,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private daoAdUser: AdUserDaoService
    ) {
        super();

        this.adUser = data.adUser;
        this.adDomain = data.adDomain;


        const formGroups = {};

        this.myForm = this.fb.group(formGroups);


        this.adUserPassword.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((password) => {
            this.myForm.markAsDirty();
            this.adPasswordWarning = buildAdPasswordInlineWarning(checkAdPasswordPolicy(password));
            this.cdr.markForCheck();
        });
        this.adUserPassword.setValidators(Validators.minLength(8));
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        // R2CLOUD-1262 — a tela só troca a senha do domínio, então o campo é a senha efetiva; confirmar
        // antes do DAO para que desistir não dispare requisição nenhuma.
        confirmAdPasswordIfNeeded(this.dialog, this.adUserPassword.value).pipe(
            filter(Boolean),
            switchMap(() => {
                this.adUserWithPassword.adUser = this.adUser;
                this.adUserWithPassword.adUserPassword = this.adUserPassword.value;
                return this.daoAdUser.saveMyPassword(this.adUserWithPassword);
            }),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((aDUserFromDAO) => {
            this.dialogRef.close(aDUserFromDAO);
        });
    }


}
